export enum SOCIAL_ISOLATION_COLORS {
  NORMAL = "#4CAF50",
  WARNING = "#FF5722",
  ALERT = "#F44336",
}